import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    pageTitle: "Home", 
    noOfNotifications: 15, 
    newNotificationMessage: "",
    newNotificationStatus: 1, 
    unreadChats  : [],
    chatNotifications: 0,
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload.title;
    },
    updateUnreadChatNotifications: (state, action) => {
      state.unreadChats = action.payload;
    },
    setChatNotifications: (state, action) => {
      state.chatNotifications = action.payload;
    },
    incrementChatNotifications: (state) => {
      state.chatNotifications += 1;
    },
    resetChatNotifications: (state) => {
      state.chatNotifications = 0;
    },

    removeNotificationMessage: (state, action) => {
      state.newNotificationMessage = "";
    },

    showNotification: (state, action) => {
      state.newNotificationMessage = action.payload.message;
      state.newNotificationStatus = action.payload.status;
    },
  },
});

export const {
  setPageTitle,
  removeNotificationMessage,
  showNotification,
  incrementChatNotifications,
  updateUnreadChatNotifications,
  setChatNotifications,
  resetChatNotifications,
} = headerSlice.actions;

export default headerSlice.reducer;
